import { render, staticRenderFns } from "./ModalPDFView.vue?vue&type=template&id=a2297cb8&"
import script from "./ModalPDFView.vue?vue&type=script&lang=js&"
export * from "./ModalPDFView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports